




















import { permissionService } from '@/services/permission.service'
import { ITableHeaderColumn } from '@/types/interfaces/table-header-column'
import { Component, Vue } from 'vue-property-decorator'
import ViewBackofficeAutorizacaoBase from './backoffice-autorizacao-base.vue'

@Component({
  components: {
    ViewBackofficeAutorizacaoBase,
  },
})
export default class ViewBackofficeRegulacao extends Vue {
  $refs!: {
    autorizacaoBase: ViewBackofficeAutorizacaoBase
  }

  readyState = false

  headers: ITableHeaderColumn[] = [
    { text: '', value: 'expand', sortable: false, active: true },
    { text: 'Paciente', value: 'pacienteNome', sortable: false, active: true },
    { text: 'Médico', value: 'medicoNome', sortable: false, active: true },
    { text: 'Convênio', value: 'convenioNome', sortable: false, active: true },
    { text: 'Caráter', value: 'carater', sortable: false, active: true },
    { text: 'P&L', value: 'categoriaDoPlanoParaFidelizacao', sortable: false, active: true },
    { text: 'Nº do pedido', value: 'protocoloOperadora', sortable: false, active: true },
    // { text: 'Nº da reserva', value: 'numeroAgendamento', sortable: false, active: true },
    { text: 'Situação', value: 'situacao', sortable: false, active: true },
    { text: 'Fidelização', value: 'statusFidelizacao', sortable: false, active: true },
    // { text: 'RA', value: 'ra', sortable: false, active: true, align: 'center' },
    { text: 'Status da cirurgia', value: 'statusCirurgia', sortable: false, active: true },
    // { text: 'SLA', value: 'statusSla', sortable: false, active: true },
    { text: 'SLA', value: 'slaRegulacao', sortable: false, active: true },
    { text: 'Ações', value: 'acoes', sortable: false, active: true, width: '157.41px' },
    { text: 'Data da cirurgia', value: 'dataAgendamento', sortable: false, active: true },
    { text: '', value: 'more', sortable: false, active: true },
  ]

  fidelizationStatuses = [
    { key: 'ProtocoloAderente', display: 'Protocolo aderente' },
    { key: 'ProtocoloNaoAderente', display: 'Protocolo não aderente' },
    { key: 'FidelizacaoAceitouJustificativa', display: 'Fidelização aceitou justificativa' },
    { key: 'PendenciaDeProtocolo', display: 'Pendência de protocolo' },
    { key: 'ProtocoloAceito', display: 'Protocolo aceito' },
    { key: 'ProtocoloRecusado', display: 'Protocolo recusado' },
    { key: 'EncaminhadoPelaRegulacao', display: 'Encaminhado pela regulação' },
    { key: 'PendenciaDeProtocoloExpirada', display: 'Pendência de protocolo expirada' },
    { key: 'AutorizadaPelaRegulacao', display: 'Autorizada pela regulação' },
    { key: 'AutorizadaParcialPelaRegulacao', display: 'Autorizada parcial pela regulação' },
    { key: 'AutorizacaoNegadaPelaRegulacao', display: 'Autorização negada pela regulação' },
  ]

  selectedFidelizationStatus = [
    'ProtocoloAderente',
    'ProtocoloNaoAderente',
    'FidelizacaoAceitouJustificativa',
    'PendenciaDeProtocolo',
    'ProtocoloAceito',
    'ProtocoloRecusado',
    'EncaminhadoPelaRegulacao',
    'PendenciaDeProtocoloExpirada',
  ]

  async init() {
    await this.$refs.autorizacaoBase.init()
    this.readyState = true
    this.getTableHeaders()
  }

  async mounted() {
    await this.init()
  }

  get situacoesIniciais() {
    return ['aguardandoOperadora']
  }

  get etapas() {
    let etapas: any = []

    if (permissionService.hasPermission('agendamento.backoffice.regulacao.filtrarPorStatusDaAutorizacao')) {
      etapas = etapas.concat([
        { key: 'analisePreAutorizacao', display: 'Análise pré-autorização', quantidade: 0 },
        { key: 'analisePreCotacao', display: 'Análise pré-cotação', quantidade: 0 },
        { key: 'revisaoCirurgicaAutorizacao', display: 'Revisão Cirúrgica', quantidade: 0 },
        { key: 'aguardandoSuprimentos', display: 'Aguardando suprimentos', quantidade: 0 },
        { key: 'emCotacao', display: 'Aguardando cotação', quantidade: 0 },
        { key: 'incompleta', display: 'Em edição', quantidade: 0 },
        { key: 'pendente', display: 'Pendência médica', quantidade: 0 },
        { key: 'pendenteDeEnvioRoboDeAutorizacao', display: 'Pendente de Autorização', quantidade: 0 },
        { key: 'pendenciaRespondida', display: 'Pendência respondida', quantidade: 0 },
        { key: 'analisePosCotacao', display: 'Análise pós-cotação', quantidade: 0 },
        { key: 'aguardandoOperadora', display: 'Aguardando autorização', quantidade: 0 },
        { key: 'respostaDoRoboDeAutorizacao', display: 'Retorno da Operadora (Robô)', quantidade: 0 },
        { key: 'retornoDaAutorizacaoDoHis', display: 'Retorno da Operadora (His)', quantidade: 0 },
        { key: 'pendenteDeEnvioRoboDeAutorizacao', display: 'Resposta Operadora', quantidade: 0 },
        { key: 'autorizadaParcial', display: 'Autorizada parcial', quantidade: 0 },
        { key: 'autorizacaoPos', display: 'Autorização Pós', quantidade: 0 },
        { key: 'autorizada', display: 'Autorizada', quantidade: 0 },
        { key: 'contestacaoMedica', display: 'Contestação Médica', quantidade: 0 },
        { key: 'contestacaoPendente', display: 'Contestação Pendente', quantidade: 0 },
      ])
    }

    if (permissionService.hasPermission('agendamento.backoffice.regulacao.filtrarPorStatusDoAgendamento')) {
      etapas = etapas.concat([
        { key: 'preAgendamento', display: 'Pré-agendamento', quantidade: 0 },
        { key: 'revisaoCirurgica', display: 'Revisão Cirúrgica', quantidade: 0 },
        { key: 'enviado', display: 'Nova solicitação', quantidade: 0 },
        { key: 'pendenciaAdministrativa', display: 'Pendência administrativa', quantidade: 0 },
        { key: 'pendente', display: 'Pendência médica', quantidade: 0 },
        { key: 'pendenciaRespondida', display: 'Pendência respondida', quantidade: 0 },
        { key: 'novaSolicitacaoParticular', display: 'Nova solicitação particular', quantidade: 0 },
        { key: 'cancelamentoSolicitado', display: 'Cancelamento solicitado', quantidade: 0 },
        { key: 'orcamentoAprovado', display: 'Orçamento aprovado', quantidade: 0 },
        { key: 'aguardandoReservaHis', display: 'Aguardando reserva no HIS', quantidade: 0 },
        { key: 'aguardandoAlteracaoDeReservaHis', display: 'Aguardando alteração de reserva no HIS', quantidade: 0 },
        { key: 'erroReservaHis', display: 'Erro ao reservar no HIS', quantidade: 0 },
        { key: 'erroAoAlterarReservaHis', display: 'Erro ao alterar reserva no HIS', quantidade: 0 },
        { key: 'incompleta', display: 'Em edição', quantidade: 0 },
        { key: 'cancelada', display: 'Cancelada', quantidade: 0 },
      ])
    }

    return etapas
  }

  get canShowFilterByStatus() {
    return permissionService.hasPermission('agendamento.backoffice.regulacao.filtrarPorStatus')
  }

  get canShowAdvancedFilters() {
    return permissionService.hasPermission('agendamento.backoffice.regulacao.filtrosAvancados')
  }

  get canShowFilterByProtocolo() {
    return permissionService.hasPermission('agendamento.backoffice.regulacao.listarProtocolos')
  }

  get canShowFilterByProtocoloProductLine() {
    return permissionService.hasPermission('agendamento.backoffice.protocolo.visualizarProductLine')
  }

  getTableHeaders() {
    const headers = localStorage.getItem('backoffice-regulacao-table-headers')
    this.headers = headers ? JSON.parse(headers) : this.headers
  }
}
